import _regeneratorRuntime from 'babel-runtime/regenerator';

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(seleccionarPuntero),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchOcultarHerramientas);

import { takeEvery, put, select } from 'redux-saga/effects';
import { GRUPO_PIZARRA, PUNTERO_ID } from '../../herramientas/constantes';
import { HERRAMIENTAS_TOGGLE, seleccionarHerramienta } from '../../actions';
import { punteroAlOcultar as punteroAlOcultarSelector } from '../../selectors/barra-herramientas';

function seleccionarPuntero(action) {
  var punteroAlOcultar;
  return _regeneratorRuntime.wrap(function seleccionarPuntero$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(punteroAlOcultarSelector);

        case 2:
          punteroAlOcultar = _context.sent;

          if (!punteroAlOcultar) {
            _context.next = 6;
            break;
          }

          _context.next = 6;
          return put(seleccionarHerramienta(PUNTERO_ID, GRUPO_PIZARRA));

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function watchOcultarHerramientas() {
  return _regeneratorRuntime.wrap(function watchOcultarHerramientas$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeEvery(HERRAMIENTAS_TOGGLE, seleccionarPuntero);

        case 2:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

export default watchOcultarHerramientas;